
import BasicCard from "../BasicCard";
import Dummylayout from "../Dummylayout";
import CreateClusterAndCompCombo from "./CreateClusterAndCompCombo";




function CreateCluster() {
    return (
        <>
            <Dummylayout/>
            <BasicCard>
                <CreateClusterAndCompCombo/>
            </BasicCard>
        </>
    )
}
export default CreateCluster;